import { mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters('annotations', ['selectedAnnotation']),
  },
  methods: {
    ...mapActions('annotations', ['resetSelectedAnnotation']),
    async highlightAnnotationAndReturnSelected() {
      return new Promise((resolve) => {
        this.$emit('highlight-annotation', true);
        let annotationSelected = false;
        const intervalId = setInterval(() => {
          if (this.selectedAnnotation !== null) {
            clearInterval(intervalId);
            annotationSelected = true;
            setTimeout(() => {
              resolve(this.selectedAnnotation);
            }, 300);
          }
        }, 100);
        setTimeout(() => {
          if (!annotationSelected) {
            clearInterval(intervalId);
            resolve(null);
          }
        }, 2000);
      });
    },
  },
};
